var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { align: "center" } }, [
    _c("h4", [_vm._v("Advertencia")]),
    _c("br"),
    _c("p", [
      _vm._v(
        "¿Esta acción no puede deshacerse ... estás seguro que deseas anular este documento?"
      )
    ]),
    _c("br"),
    _c(
      "div",
      { staticStyle: { float: "right" } },
      [
        _c(
          "vs-button",
          {
            attrs: { color: "primary", type: "filled" },
            on: { click: _vm.anular }
          },
          [_vm._v("Anular documento")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }